import { getVideoSource, isDigitalMediaAllowed, getUnsupportedUrlMessage } from './video-utils';

function getDigitalMediaVideoCode(url) {
  try {
    const u = new URL(url);
    const playMatch = u.pathname.match(/\/Mediasite\/Play\/([a-f0-9]+)/i);
    if (playMatch?.[1]) return playMatch[1];

    const presMatch = u.pathname.match(/\/Presentation\/([a-f0-9]+)/i);
    if (presMatch?.[1]) return presMatch[1];

    return '';
  } catch {
    return '';
  }
}

function youtubeEmbed(url) {
  try {
    const u = new URL(url);
    let videoId = '';

    if (u.hostname.includes('youtube.com')) {
      videoId = u.searchParams.get('v') || '';
      if (!videoId && u.pathname.startsWith('/embed/')) {
        videoId = u.pathname.split('/embed/')[1];
      }
    } else if (u.hostname === 'youtu.be') {
      videoId = u.pathname.replace('/', '');
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
  } catch {
    return url;
  }
}

function vimeoEmbed(url) {
  try {
    const u = new URL(url);
    const parts = u.pathname.split('/').filter(Boolean);
    const videoId = parts[0];
    return videoId ? `https://player.vimeo.com/video/${videoId}` : url;
  } catch {
    return url;
  }
}

async function fetchAuthToken(videoCode) {
  const res = await fetch(
    `/wp-json/digitalmedia/v1/auth-token/?video_code=${encodeURIComponent(videoCode)}`
  );
  if (!res.ok) throw new Error('Failed to fetch DigitalMedia auth token');
  const data = await res.json();
  return data.authToken;
}

function replaceWithPlaceholder(iframe, message) {
  if (!iframe || !iframe.parentNode) return;
  const ph = document.createElement('div');
  ph.className = 'video-placeholder';
  ph.textContent = message;
  iframe.parentNode.replaceChild(ph, iframe);
}

async function hydrateDigitalMediaIframe(iframe, rawUrl) {
  if (!rawUrl) return;

  if (!isDigitalMediaAllowed()) {
    replaceWithPlaceholder(iframe, getUnsupportedUrlMessage('digitalmedia'));
    return;
  }

  const videoCode = getDigitalMediaVideoCode(rawUrl);
  if (!videoCode) return;

  const token = await fetchAuthToken(videoCode);

  iframe.src =
    `https://digitalmedia.sandia.gov/Mediasite/Play/${videoCode}` +
    `?AuthTicket=${encodeURIComponent(token)}` +
    `&autostart=false&player=50a54cab1d3541bc913f556ea1b6df590a&playfrom=0&covertitle=false`;
}

function hydrateGenericIframe(iframe, rawUrl) {
  if (!rawUrl) return;

  const source = getVideoSource(rawUrl);

  if (source === 'youtube') iframe.src = youtubeEmbed(rawUrl);
  else if (source === 'vimeo') iframe.src = vimeoEmbed(rawUrl);
  else iframe.src = rawUrl;
}

async function init() {
  const root = document;
  const iframes = root.querySelectorAll('.wp-block-snl-video iframe');

  for (const iframe of iframes) {
    const rawUrl = iframe.getAttribute('src');
    if (!rawUrl) continue;

    const source = getVideoSource(rawUrl);

    if (source === 'digitalmedia') {
      try {
        await hydrateDigitalMediaIframe(iframe, rawUrl);
      } catch (e) {
        console.error(e);
      }
      continue;
    }

    if (source === 'youtube' || source === 'vimeo' || source === 'digitalops') {
      hydrateGenericIframe(iframe, rawUrl);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}